import { clsx } from "clsx";

type Variant = "high" | "medium" | "low" | "beat" | "miss" | "inline" | "bullish" | "bearish" | "neutral";

const variantClasses: Record<Variant, string> = {
  high: "bg-red-100 text-red-700",
  medium: "bg-yellow-100 text-yellow-700",
  low: "bg-green-100 text-green-700",
  beat: "bg-green-100 text-green-700",
  miss: "bg-red-100 text-red-700",
  inline: "bg-gray-100 text-gray-600",
  bullish: "bg-emerald-100 text-emerald-700",
  bearish: "bg-red-100 text-red-700",
  neutral: "bg-gray-100 text-gray-600",
};

const labels: Record<Variant, string> = {
  high: "HIGH",
  medium: "MED",
  low: "LOW",
  beat: "BEAT",
  miss: "MISS",
  inline: "IN LINE",
  bullish: "BULLISH",
  bearish: "BEARISH",
  neutral: "NEUTRAL",
};

export function Badge({ variant, className }: { variant: Variant; className?: string }) {
  return (
    <span
      className={clsx(
        "inline-flex items-center px-1.5 py-0.5 rounded text-xs font-semibold",
        variantClasses[variant],
        className
      )}
    >
      {labels[variant]}
    </span>
  );
}

export function ImpactBadge({ level }: { level: string }) {
  const v = level.toLowerCase() as Variant;
  return <Badge variant={v} />;
}

export function SurpriseBadge({ direction }: { direction: string | null }) {
  if (!direction) return null;
  const map: Record<string, Variant> = { BEAT: "beat", MISS: "miss", IN_LINE: "inline" };
  return <Badge variant={map[direction] ?? "inline"} />;
}

export function MarketViewBadge({ view }: { view: string }) {
  const map: Record<string, Variant> = { BULLISH: "bullish", BEARISH: "bearish", NEUTRAL: "neutral" };
  return <Badge variant={map[view.toUpperCase()] ?? "neutral"} />;
}
